import {
  Flex,
  space,
  StatusIndicator,
  StatusIndicatorEmphasis,
  StatusIndicatorType,
  Text
} from '@workday/canvas-kit-react'
import React from 'react'
import { fontSizes } from '@workday/canvas-kit-react/dist/es6/tokens/lib/type/fontSizes'
import TimeDisplayOption from '../models/TimeDisplayOptions'
import { IncidentModel } from '../../models/IncidentModel'
import { AgencyModel } from '../../models/AgencyModel'
import {
  arrowCircleIcon,
  clockCheckIcon,
  clockExclamationIcon,
  commentActiveIcon
} from '@workday/canvas-system-icons-web'

export interface IncidentCardProps {
  timeDisplayOption: TimeDisplayOption
  incident: IncidentModel
  agency: AgencyModel
  showAgencyTitle: boolean
}

const IncidentCard = ({ timeDisplayOption, incident, agency, showAgencyTitle }: IncidentCardProps) => {
  const duration = incident.formattedElapsedTime(true)
  const alarmLevel = incident.alarmLevelDescription()
  const incidentPosts = incident.incidentPostsDescription()

  return (
    <Flex flexDirection="column" gap={space.xxs}>
      <Flex flexDirection="row" alignItems="center" gap={space.xxs}>
        {showAgencyTitle && (
          <>
            <Text typeLevel="subtext.large">{agency?.shortName}</Text>
            {incident.isProData && <img src="/images/verified_gray.png" style={{ height: fontSizes[14] }} />}
            <Flex.Item flex="1" />
            <Text typeLevel="subtext.large" fontWeight="medium">
              {timeDisplayOption === 'LOCAL' && incident.formattedCallRecivedDateTime(undefined, true)}
              {timeDisplayOption === 'AGENCY' && incident.formattedCallRecivedDateTime(agency.timeZone, true)}
              {timeDisplayOption === 'BOTH' &&
                `${incident.formattedCallRecivedDateTime(undefined, true)} (${incident.formattedCallRecivedDateTime(
                  agency.timeZone,
                  false
                )})`}
            </Text>
          </>
        )}
      </Flex>
      <Flex flexDirection="row" gap={space.xxs}>
        <img src={incident.listIconURL()} width={42} height={42} />
        <Flex flexDirection="column" alignItems="start" width={'100%'}>
          <Flex flexDirection='row' alignItems='start' width={'100%'}>
            <Text typeLevel="body.large" fontWeight="bolder">{incident.callTypeDescription()}</Text>
            {!showAgencyTitle && (
            <>
              <Flex.Item flex="1" />
              <Text typeLevel="subtext.medium" fontWeight="medium">
                {timeDisplayOption === 'LOCAL' && incident.formattedCallRecivedDateTime(undefined, true)}
                {timeDisplayOption === 'AGENCY' && incident.formattedCallRecivedDateTime(agency.timeZone, true)}
                {timeDisplayOption === 'BOTH' &&
                  `${incident.formattedCallRecivedDateTime(undefined, true)} (${incident.formattedCallRecivedDateTime(
                    agency.timeZone,
                    false
                  )})`}
              </Text>
            </>
          )}
          </Flex>
          <Flex flexDirection="row" flexWrap="wrap" gap={space.xxs}>
            {duration !== '' && (
              <StatusIndicator
                emphasis={StatusIndicatorEmphasis.Low}
                label={`Closed - Duration ${duration}`}
                type={StatusIndicatorType.Gray}
                icon={clockCheckIcon}
              />
            )}
            {incidentPosts && (
              <StatusIndicator
                emphasis={StatusIndicatorEmphasis.Low}
                label={incidentPosts}
                type={StatusIndicatorType.Blue}
                icon={commentActiveIcon}
              />
            )}
            {alarmLevel && (
              <StatusIndicator
                emphasis={StatusIndicatorEmphasis.Low}
                label={alarmLevel}
                type={StatusIndicatorType.Red}
                icon={arrowCircleIcon}
              />
            )}
          </Flex>

          <Text typeLevel="subtext.large">{incident.fullDisplayAddress}</Text>
          <Flex flexDirection="row" flexWrap="wrap" gap={space.xxs} style={{marginTop: "4px"}}>
            {incident.units.map(unitModel => (
              <Text typeLevel="subtext.medium" fontWeight="medium" key={unitModel.id}>
                <span style={{ color: unitModel.statusColor() }}>{unitModel.displayID()}</span>
              </Text>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default IncidentCard
